import React from "react";
import { Button } from "react-bootstrap";
import { useFormContext } from "react-hook-form";
import { useHistory } from "react-router-dom";
import { InternalAgentSelect } from "../components";
import AddressForm from "../components/order/AddressForm";
import { Bundles } from "../components/products";
import { useUser } from "../context/UserContext";
import { isInternal, setToken } from "../helpers";
import { useResetForm } from "../hooks/useResetForm";
import SliderPage from "./hoc/SliderPage";

const NewOrderPage = () => {
  const resetForm = useResetForm({
    address_info: { full_address: null, unit_number: "" },
    order_info: { sq_ft: "" },
    user_id: null,
  });
  const { setValue } = useFormContext();
  const history = useHistory();
  const { user } = useUser();
  const logOut = () => {
    setToken();
    setValue("user_id", null);
    history.push("/");
  };

  return (
    <SliderPage title="New Order">
      <>
        {isInternal() && (
          <Button className="mb-4" onClick={resetForm}>
            Reset Form
          </Button>
        )}
        {user && !isInternal() && (
          <div className="mb-5">
            <span className="h2 mr-3">Welcome {user.name}!</span>
            <span className="text-muted">
              {user && (
                <>
                  <span>Not you?</span>{" "}
                  <span className="text-link" onClick={logOut}>
                    Sign Out
                  </span>
                </>
              )}
            </span>
          </div>
        )}
        <InternalAgentSelect />
        <AddressForm />
        <Bundles />
      </>
    </SliderPage>
  );
};

export default NewOrderPage;
